module.exports = __webpack_public_path__ + "img/main_game_d720.77076de5.png";